import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { LayoutDashboard, Users, Briefcase, Settings, LogOut } from 'lucide-react';
import { toast } from 'sonner';
import BrandLogo from './BrandLogo';

const AdminLayout = ({ children }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const adminName = localStorage.getItem('admin_name') || 'Admin';

  const handleLogout = () => {
    localStorage.removeItem('admin_token');
    localStorage.removeItem('admin_name');
    toast.success('Logged out successfully');
    navigate('/admin/login');
  };

  const menuItems = [
    { icon: LayoutDashboard, label: 'Dashboard', path: '/admin/dashboard' },
    { icon: Briefcase, label: 'Test Jobs', path: '/admin/test-jobs' },
    { icon: Users, label: 'Clients', path: '/admin/clients' },
    { icon: Settings, label: 'Settings', path: '/admin/settings' },
  ];

  return (
    <div className="min-h-screen bg-zinc-50/50 flex">
      {/* Sidebar */}
      <div className="w-64 border-r border-zinc-200 bg-white h-screen fixed left-0 top-0 z-30 admin-sidebar">
        <div className="p-6">
          <div className="flex items-center gap-3 mb-8">
            <BrandLogo className="h-10" />
            <p className="text-xs text-zinc-500">Admin Panel</p>
          </div>

          <nav className="space-y-2">
            {menuItems.map((item) => {
              const Icon = item.icon;
              const isActive = location.pathname === item.path;
              return (
                <Link
                  key={item.path}
                  to={item.path}
                  data-testid={`nav-${item.label.toLowerCase().replace(' ', '-')}`}
                  className={`flex items-center gap-3 px-4 py-3 rounded-lg transition-colors ${
                    isActive
                      ? 'bg-zinc-900 text-white'
                      : 'text-zinc-600 hover:bg-zinc-100 hover:text-zinc-900'
                  }`}
                >
                  <Icon className="w-5 h-5" />
                  <span className="font-medium">{item.label}</span>
                </Link>
              );
            })}
          </nav>
        </div>

        <div className="absolute bottom-0 left-0 right-0 p-6 border-t border-zinc-200">
          <div className="mb-3 px-4">
            <p className="text-sm font-medium text-zinc-900">{adminName}</p>
            <p className="text-xs text-zinc-500">Administrator</p>
          </div>
          <button
            data-testid="logout-btn"
            onClick={handleLogout}
            className="flex items-center gap-3 px-4 py-3 rounded-lg text-red-600 hover:bg-red-50 w-full transition-colors"
          >
            <LogOut className="w-5 h-5" />
            <span className="font-medium">Logout</span>
          </button>
        </div>
      </div>

      {/* Main Content */}
      <div className="flex-1 md:ml-64 p-8">
        {children}
      </div>
    </div>
  );
};

export default AdminLayout;